// fungsi untuk unpack data dari setiap sensor
import { Buffer } from "buffer";

const UnpackData = (group, buffer) => {
  const ForAcc = () => {
    // console.log('len buffer', buffer.length);
    let indexBufferPack = 0;

    const wadah = {
      "Accelerometer X": [],
      "Accelerometer Y": [],
      "Accelerometer Z": [],
    };
    const temp = [];
    for (let i = 0; i < buffer.length; i += 6) {
      const stringPack = buffer.slice(i, i + 6);
      const floatValue = Buffer.from(stringPack + "==", "base64").readFloatBE(
        0
      );
      // console.log("String pack", floatValue);
      temp.push(floatValue);
      // distribute a unpack value to every array buffer
      if (indexBufferPack === 2) {
        wadah["Accelerometer Z"].push(floatValue);
        indexBufferPack = -1;
      } else if (indexBufferPack === 1) {
        wadah["Accelerometer Y"].push(floatValue);
      } else if (indexBufferPack === 0) {
        wadah["Accelerometer X"].push(floatValue);
      }
      indexBufferPack++;
    }
    // console.log("wadah temp", temp.length, buffer.length);
    return wadah;
  };
  const ForStr = () => {
    // console.log('len buffer', buffer.length);

    const wadah = {
      Strain: [],
    };

    for (let i = 0; i < buffer.length; i += 6) {
      const stringPack = buffer.slice(i, i + 6);
      const floatValue = Buffer.from(stringPack + "==", "base64").readFloatBE(
        0
      );
      // console.log("String pack", floatValue);
      wadah["Strain"].push(floatValue);
    }
    // console.log("wadah temp", wadah["LVDT"], buffer.length);
    return wadah;
  };
  const ForGyr = () => {
    let indexBufferPack = 0;
    const wadah = {
      "Gyroscope X": [],
      "Gyroscope Pitch Y": [],
      "Gyroscope Roll Z": [],
    };
    const temp = [];

    for (let i = 0; i < buffer.length; i += 6) {
      const stringPack = buffer.slice(i, i + 6);
      const floatValue = Buffer.from(stringPack + "==", "base64").readFloatBE(
        0
      );
      // console.log("String pack", floatValue);
      temp.push(floatValue);
      // distribute a unpack value to every array buffer
      if (indexBufferPack === 2) {
        wadah["Gyroscope Roll Z"].push(floatValue);
        indexBufferPack = -1;
      } else if (indexBufferPack === 1) {
        wadah["Gyroscope Pitch Y"].push(floatValue);
      } else if (indexBufferPack === 0) {
        // wadah["Gyroscope X"].push(floatValue);
      }
      indexBufferPack++;
    }
    // console.log("wadah temp", temp.length, buffer.length);
    return wadah;
  };
  const ForLvd = () => {
    const wadah = {
      LVDT: [],
    };
    const floatValue = Buffer.from(buffer + "==", "base64").readFloatBE(0);
    wadah["LVDT"].push(floatValue);

    return wadah;
  };
  const ForTem = () => {
    const wadah = {
      Temperature: [],
    };
    const floatValue = Buffer.from(buffer + "==", "base64").readFloatBE(0);
    wadah["Temperature"].push(floatValue);

    return wadah;
  };

  switch (group) {
    case "Accelerometer":
      return ForAcc();
    case "Strain":
      return ForStr();
    case "Gyroscope":
      return ForGyr();
    case "LVDT":
      return ForLvd();
    case "Temperature":
      return ForTem();
    default:
      return null;
  }
};

// fungsi untuk menyebar time pada setiap data
const UnpackLabel = (ts, length, sampleRate) => {
  const time = 1000 / sampleRate;
  let labelData = [];
  let temp = ts;
  for (let index = 0; index < length; index++) {
    temp -= time;
    labelData.push(temp);
  }
  labelData = labelData.reverse();
  return labelData;
};

// sensro props
export const SensorProps = {
  Temperature: {
    max: 40,
    min: 5,
    satuan: " °C",
    ttl: 12000,
    delay: 1000,
    step: 2,
    refresh: 1000,
  },
  Accelerometer: {
    max: 0.5,
    min: -0.5,
    satuan: " G",
    ttl: 12000,
    delay: 1000,
    step: 0.1,
    refresh: 500,
  },
  Strain: {
    max: 50,
    min: -10,
    satuan: " µε",
    ttl: 13000,
    delay: 1000,
    step: 10,
    refresh: 1000,
  },
  Gyroscope: {
    max: 5.5,
    min: -5.5,
    satuan: " °",
    ttl: 12000,
    delay: 1000,
    step: 0.2,
    refresh: 1000,
  },
  LVDT: {
    max: 10,
    min: -10,
    satuan: " mm",
    ttl: 12000,
    delay: 1000,
    step: 1,
    refresh: 1000,
  },
};

export const ToCamelCase = (str) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

export const SwitchSatuanPD = (title) => {
  switch (title.toLowerCase()) {
    case "arus":
      return "A";
    case "rssi":
      return "dBm";
    default:
      return "v";
  }
};

export { UnpackLabel, UnpackData };
